import { Box, Stack } from '@mui/system'
import { FC } from 'react'
import { EscalateToIntrusionWithDescriptionOutdoorActivity, OutdoorEngagement, ProcessedActivity } from '../../../../../../api/models'
import { ActivityTimingResult } from '../useActivityTiming'
import { ActivityFieldBox } from '../ActivityFieldBox'
import { MISSING_VALUE } from '../../../../../../constants'
import { FIELD_LABEL_PEOPLE_OBSERVED, FIELD_LABEL_RESOLUTION_CATEGORY } from '../ActivityCard.constants'
import { SharedActivity, SharedActivityProps } from './SharedActivity'
import { EqualColumnsGrid } from '../../EqualColumnsGrid'
import { useLocationCameras } from '../../../../../../api/apiQueries'
import { camelCaseToSplitWords } from '../../../activityUtils'

type EscalateToIntrusionActivityProps = SharedActivityProps & {
  activity: Extract<ProcessedActivity, EscalateToIntrusionWithDescriptionOutdoorActivity>
  engagement: OutdoorEngagement
  timing: ActivityTimingResult
}

export const EscalateToIntrusionActivity: FC<EscalateToIntrusionActivityProps> = ({ activity, engagement, timing }) => {
  const cameraId = engagement.result?.escalation?.cameraId
  const { data: cameras } = useLocationCameras(engagement.locationId)
  const cameraName = cameras?.find(c => c.uuid === cameraId)?.name ?? MISSING_VALUE

  return (
    <Stack direction="column" sx={{ gap: 'var(--spacing-2xs)' }}>
      <SharedActivity activity={activity} engagement={engagement} timing={timing} />
      {engagement.result?.resolution?.category && (
        <ActivityFieldBox label={FIELD_LABEL_RESOLUTION_CATEGORY} labelTestId="activity-card-resolution-category">
          {camelCaseToSplitWords(engagement.result?.resolution?.category)}
        </ActivityFieldBox>
      )}
      <ActivityFieldBox label="Escalation Reason" labelTestId="activity-card-escalation-reason">
        <Box data-testid="activity-card-escalation-reason-value">{engagement.result?.escalation?.escalationNote || MISSING_VALUE}</Box>
      </ActivityFieldBox>
      <EqualColumnsGrid>
        <ActivityFieldBox label="Which Camera">
          <Box data-testid="activity-card-which-camera-value">{cameraName}</Box>
        </ActivityFieldBox>
        <ActivityFieldBox label={FIELD_LABEL_PEOPLE_OBSERVED}>
          <Box data-testid="activity-card-people-observed-value">{engagement.result?.escalation?.numberOfPeopleObserved ?? 'Zero'}</Box>
        </ActivityFieldBox>
      </EqualColumnsGrid>
    </Stack>
  )
}
